import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {UploadComponent} from './components/upload/upload.component';
import {SuccessPageComponent} from '../../shared/components/success-page/success-page.component';
import {SuccessGuardService} from '../../shared/services/guard-services/success-guard.service';
import { UploadVideoComponent } from "./components/video/upload-video.component";

const routes: Routes = [
    {
        path: '',
        component: UploadComponent
    },
    {
        path: 'video/:id',
        component: UploadVideoComponent
    },
    {
        path: 'video',
        component: UploadVideoComponent
    },
    {
        path: ':id/:action',
        component: SuccessPageComponent,
        canActivate: [SuccessGuardService]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [SuccessGuardService]
})
export class UploadRoutingModule {
}
